import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CancelIcon from '@material-ui/icons/Cancel';
import Typography from 'Components/UI/Typography';
import SyncIcon from '@material-ui/icons/Sync';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import IconButton from '@material-ui/core/IconButton';
import MetaReadOnlyView from 'Components/UI/Meta/MetaReadOnlyView';

const styles = theme => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
  },
  header: {
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'space-between',
  },
  readOnlyInfo: {
    flex: 10,
  },
  headerRightSide: {
    display: 'flex',
    flexFlow: 'row',
  },
  refreshButton: {
    marginRight: theme.spacing(1),
  },
  closeButton: {
    flex: 1,
    paddingTop: 0,
  },
});

const View = ({
  classes, resource, onClose, onClickRefresh,
}) => {
  return (
    <Box className={classes.root}>
      <Box debugColor="lightSeaGreen">
        <div className={classes.header}>
          <div className={classes.readOnlyInfo}>
            <Typography
              variant="h4"
              color={resource.attr('hidden') === 'true' ? 'red' : 'primary'}
              className={classes.title}
            >
              {resource.attr('hidden') === 'true'
                ? 'Account Info (Cancelled)'
                : 'Account Info'}
            </Typography>
          </div>
          <div className={classes.headerRightSide}>
            <IconButton
              className={classes.refreshButton}
              onClick={onClickRefresh}
              variant="contained"
              color="primary"
            >
              <SyncIcon />
            </IconButton>
            <IconButton color="primary" onClick={onClose}>
              <CancelIcon />
            </IconButton>
          </div>
        </div>
        <MetaReadOnlyView
          resource={resource}
          hiddenFields={[
            'total',
            'unAdjustedTotal',
            'startDayCashAvailable',
            'pendingDebitInterest',
            'pendingDebitDividends',
            'fullyPaidUnsettledFunds',
            'includesFullyPaidUnsettledFunds',
            'totalDeposits',
            'totalDisbursements',
            'hidden',
            'isFunded',
          ]}
        />
      </Box>
    </Box>
  );
};

View.propTypes = {
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onClickRefresh: PropTypes.func.isRequired,
};

export default withStyles(styles)(View);
